<template>
  <v-card 
    class="pa-6" 
    width="400"
    style="border-radius: 32px;"
    >
    <v-card-title class="text-h5">INP-Platzbuchung</v-card-title>
    <v-card-title class="text-h7" style="margin-left: 17px;">Login</v-card-title>

    <v-alert
      v-if="errorMessage"
      type="error"
      class="ma-4"
      dense
      outlined
    >
      {{ errorMessage }}
    </v-alert>

    <v-alert
      v-if="resetMessage"
      type="success"
      class="ma-4"
      dense
      outlined
    >
      {{ resetMessage }}
    </v-alert>

    <v-card-text>
      <v-form @submit.prevent="handleLogin">
        <v-text-field
            v-model="username"
            label="Benutzername"
            prepend-inner-icon="mdi-account"
            required
        ></v-text-field>
        
        <v-btn 
          variant="text" 
          color="onBackground"
          style="text-decoration: underline;"
          @click.prevent="handlePasswordReset"
          >
          Passwort vergessen ?
        </v-btn>

        <v-text-field
          v-model="password"
          label="Passwort"
          prepend-inner-icon="mdi-lock"
          :type="showPassword ? 'text' : 'password'"
          :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="togglePasswordVisibility"
          required
        ></v-text-field>

        <v-btn type="submit" color="#FF7500" class="mt-4" block>
          Anmelden
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {

  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      resetMessage: '',
      showPassword: false
    };
  },

  methods: {
    async handleLogin() {
      try {
        const response = await this.$axios.post('/api-token-auth/', {
          username: this.username,
          password: this.password,
        });

        // Token wirklich auslesen
        const token = response.data.token;
        if (!token) {
          throw new Error("Kein Token erhalten!");
        }

        // Token speichern
        localStorage.setItem('access_token', token);

        // Benutzerinfos laden
        //await this.$axios.get("/api/users/");

        // Weiterleiten
        this.$router.push({ name: 'Dashboard' });

      } catch (error) {
        console.error('Login fehlgeschlagen:', error);
        this.errorMessage = 'Benutzername oder Passwort falsch!';
        this.clearMessages();
      }
    },

    async handlePasswordReset() {
      if (!this.username) {
        this.errorMessage = 'Bitte geben Sie Ihren Benutzernamen ein.';
        this.clearMessages();
        return;
      }

      try {
        await this.$axios.post('/api/users/reset-password/', {
          username: this.username
        });

        this.resetMessage = 'Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet.';
        this.clearMessages();

      } catch (error) {
        this.errorMessage =
          'Kein registrierter Nutzername. Bitte tragen Sie einen gültigen Benutzernamen ein.';
        this.clearMessages();
      }
    },

    clearMessages() {
      setTimeout(() => {
        this.errorMessage = '';
        this.resetMessage = '';
      }, 3000);
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>
